"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BulkUploadCountButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _withAPIData = require("../api/withAPIData");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("axios/index"));

var _reactstrap = require("reactstrap");

var _excluded = ["url", "axiosInstance", "children", "destinationUrl", "outline", "color"];

function BulkUploadCountButton(_ref) {
  var url = _ref.url,
      axiosInstance = _ref.axiosInstance,
      children = _ref.children,
      destinationUrl = _ref.destinationUrl,
      _ref$outline = _ref.outline,
      outline = _ref$outline === void 0 ? true : _ref$outline,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "danger" : _ref$color,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  function onClick() {
    document.location = destinationUrl;
  }

  return /*#__PURE__*/_react["default"].createElement(_withAPIData.WithAPIData, {
    axiosInstance: axiosInstance,
    url: "".concat(url, "?summary=true")
  }, function (_ref2) {
    var data = _ref2.data,
        loading = _ref2.loading;
    return loading === false && data.count > 0 && /*#__PURE__*/_react["default"].createElement(_reactstrap.Button, (0, _extends2["default"])({
      type: "button",
      outline: outline,
      color: color
    }, rest, {
      onClick: onClick
    }), children || "Errors", loading === false && /*#__PURE__*/_react["default"].createElement("span", {
      className: "badge badge-danger ml-2",
      style: {
        padding: "4px 6px"
      }
    }, data.count));
  });
}

BulkUploadCountButton.propTypes = {
  axiosInstance: _propTypes["default"].func.isRequired,
  url: _propTypes["default"].string.isRequired,
  destinationUrl: _propTypes["default"].string.isRequired
};
BulkUploadCountButton.defaultProps = {
  axiosInstance: _index["default"]
};